import Vue from 'vue';
import {
  MEDIAS,
  MULTI_SELECT,
  INIT_MULTI_SELECT,
} from './mutation-types';

export default {

  [MEDIAS](state, response) {
    state.medias = response.medias;
  },

  [MULTI_SELECT](state, params) {
    state.multipleSelection[params.page] = params.multipleSelection;
  },

  [INIT_MULTI_SELECT](state) {
    state.multipleSelection = [];
  },

};
